import { useState, useContext } from "react";
import { domain } from "../consts";
import { AlertContext } from "../context/AlertContext";
import EditableText from "./EditableText";
import { RefreshSVG } from "./SVG";
import confetti from "canvas-confetti";

const InvitationForm = ({ rsvp, isEditable = false, onUpdate = () => {} }) => {
  function runConfetti(particleCount) {
    confetti({
      particleCount,
      spread: 70,
      origin: { y: 0.6 },
      colors: ["#ffd700", "#ff69b4", "#ff1493", "#87ceeb", "#98fb98"],
    });
  }
  const [formData, setFormData] = useState({
    guestName: "",
    phoneNumber: "",
    email: "",
    isComing: true,
    needsAccommodation: false,
    personalMessage: "",
    additionalGuests: [],
  });

  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(() => {
    const submittedRsvps = JSON.parse(
      localStorage.getItem("submittedRsvps") || "[]",
    );
    return submittedRsvps.includes(rsvp.id);
  });
  const { handleAlert } = useContext(AlertContext);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isEditable) return;
    setSubmitting(true);
    setSubmitSuccess(null);

    try {
      const response = await fetch(`${domain}/response/${rsvp.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (response.ok) {
        runConfetti(200);
        setSubmitSuccess(data.message || "Form successfully submitted!");
        const submittedRsvps = JSON.parse(
          localStorage.getItem("submittedRsvps") || "[]",
        );
        if (!submittedRsvps.includes(rsvp.id)) {
          submittedRsvps.push(rsvp.id);
          localStorage.setItem(
            "submittedRsvps",
            JSON.stringify(submittedRsvps),
          );
        }
        setFormData({
          guestName: "",
          phoneNumber: "",
          email: "",
          isComing: false,
          needsAccommodation: false,
          personalMessage: "",
          additionalGuests: [],
        });
        setTimeout(() => runConfetti(500), 200);
      } else {
        if (response.status === 403) {
          throw new Error("Nažalost, dosegnut je maksimalan broj gostiju.");
        }
        throw new Error("Došlo je do greške prilikom slanja forme.");
      }
    } catch (error) {
      handleAlert(error.message, "error");
    } finally {
      setSubmitting(false);
    }
  };
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    const inputValue = type === "checkbox" ? checked : value;
    setFormData({ ...formData, [name]: inputValue });
  };

  const addAdditionalName = () => {
    if (isEditable) return;
    setFormData({
      ...formData,
      additionalGuests: [...formData.additionalGuests, ""],
    });
  };

  const handleRemoveName = (index) => {
    setFormData({
      ...formData,
      additionalGuests: formData.additionalGuests.filter((_, i) => i !== index),
    });
  };

  const handleAdditionalNameChange = (index, value) => {
    const updatedNames = [...formData.additionalGuests];
    updatedNames[index] = value;
    setFormData({ ...formData, additionalGuests: updatedNames });
  };

  return (
    <div className={`my-12 font-display`}>
      <div className="max-w-lg p-8 shadow-xl mt-10 rounded-lg min-h-96 mx-4 sm:mx-auto">
        {isEditable && (
          <div className=" w-full flex justify-end top-1 h-8 p-2 rounded-full my-2 translate-x-6">
            <div
              onClick={() => setSubmitSuccess((prev) => !prev)}
              className="border-2 border-dashed border-gray-200 h-6 w-6"
            >
              <RefreshSVG />
            </div>
          </div>
        )}
        {submitSuccess ? (
          <div className="min-h-44 flex items-center justify-center animate-fade-up">
            <div className={isEditable ? "" : "animate-fade-down"}>
              <EditableText
                text={rsvp.formSuccessText}
                onTextChange={(text) => onUpdate({ formSuccessText: text })}
                className={`font-bold text-center font-${rsvp.formSuccessFont}`}
                style={{
                  color: rsvp.formSuccessColor,
                  fontSize: `${rsvp.formSuccessFontSize}px`,
                }}
                font={rsvp.formSuccessFont}
                color={rsvp.formSuccessColor}
                fontSize={rsvp.formSuccessFontSize}
                isBold={rsvp.formSuccessIsBold}
                isItalic={rsvp.formSuccessIsItalic}
                onStyleChange={(style) => {
                  if (style.font) onUpdate({ formSuccessFont: style.font });
                  if (style.color) onUpdate({ formSuccessColor: style.color });
                  if (style.fontSize)
                    onUpdate({ formSuccessFontSize: style.fontSize });
                  if (style.isBold !== undefined)
                    onUpdate({ formSuccessIsBold: style.isBold });
                  if (style.isItalic !== undefined)
                    onUpdate({ formSuccessIsItalic: style.isItalic });
                }}
                isEditable={isEditable}
              />
            </div>
          </div>
        ) : (
          <div className="animate-fade-down">
            <>
              <EditableText
                text={rsvp.formTitleText}
                onTextChange={(text) => onUpdate({ formTitleText: text })}
                className={`font-bold text-center mb-4 font-${rsvp.formTitleFont}`}
                style={{
                  color: rsvp.formTitleColor,
                  fontSize: `${rsvp.formTitleFontSize}px`,
                }}
                font={rsvp.formTitleFont}
                color={rsvp.formTitleColor}
                fontSize={rsvp.formTitleFontSize}
                isBold={rsvp.formTitleIsBold}
                isItalic={rsvp.formTitleIsItalic}
                onStyleChange={(style) => {
                  if (style.font) onUpdate({ formTitleFont: style.font });
                  if (style.color) onUpdate({ formTitleColor: style.color });
                  if (style.fontSize)
                    onUpdate({ formTitleFontSize: style.fontSize });
                  if (style.isBold !== undefined)
                    onUpdate({ formTitleIsBold: style.isBold });
                  if (style.isItalic !== undefined)
                    onUpdate({ formTitleIsItalic: style.isItalic });
                }}
                isEditable={isEditable}
                tag="h2"
              />
              <EditableText
                text={rsvp.formSubtitleText}
                onTextChange={(text) => onUpdate({ formSubtitleText: text })}
                className={`text-center mb-8 italic font-${rsvp.formSubtitleFont}`}
                style={{
                  color: rsvp.formSubtitleColor,
                  fontSize: `${rsvp.formSubtitleFontSize}px`,
                }}
                font={rsvp.formSubtitleFont}
                color={rsvp.formSubtitleColor}
                fontSize={rsvp.formSubtitleFontSize}
                isBold={rsvp.formSubtitleIsBold}
                isItalic={rsvp.formSubtitleIsItalic}
                onStyleChange={(style) => {
                  if (style.font) onUpdate({ formSubtitleFont: style.font });
                  if (style.color) onUpdate({ formSubtitleColor: style.color });
                  if (style.fontSize)
                    onUpdate({ formSubtitleFontSize: style.fontSize });
                  if (style.isBold !== undefined)
                    onUpdate({ formSubtitleIsBold: style.isBold });
                  if (style.isItalic !== undefined)
                    onUpdate({ formSubtitleIsItalic: style.isItalic });
                }}
                isEditable={isEditable}
              />

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <input
                    type="text"
                    id="guestName"
                    name="guestName"
                    placeholder="Ime i prezime"
                    value={formData.guestName}
                    onChange={handleChange}
                    required
                    className={`w-full p-3 border rounded-md text-gray-800`}
                    style={{ borderColor: rsvp.formAddGuestColor }}
                    disabled={isEditable}
                  />
                </div>

                {rsvp?.includePhone && (
                  <div className={`flex ${!rsvp?.includePhone && "hidden"}`}>
                    <input
                      type="text"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Telefon"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      className="w-full p-3 border border-yellow-500 rounded-md text-gray-800"
                      style={{ borderColor: rsvp.formAddGuestColor }}
                      disabled={isEditable}
                    />
                  </div>
                )}

                {rsvp?.includeEmail && (
                  <div className={`flex ${!rsvp?.includeEmail && "hidden"}`}>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email adresa"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full p-3 border border-yellow-500 rounded-md text-gray-800"
                      style={{ borderColor: rsvp.formAddGuestColor }}
                      disabled={isEditable}
                    />
                  </div>
                )}
                <div className={`flex ${!rsvp?.formAccommodation && "hidden"}`}>
                  <input
                    disabled={!formData.isComing}
                    type="checkbox"
                    name="needsAccommodation"
                    onChange={handleChange}
                    className={`shrink-0 mt-0.5 border rounded cursor-pointer disabled:opacity-50 disabled:pointer-events-none      :ring-offset-gray-800`}
                    style={{
                      borderColor: rsvp.formAddGuestColor,
                      color: rsvp.formAddGuestColor,
                      "--tw-ring-color": rsvp.formAddGuestColor,
                    }}
                    id="hs-default-checkbox"
                  />
                  <label
                    htmlFor="hs-default-checkbox"
                    className="text-gray-500 ms-3  "
                  >
                    {formData.additionalGuests.length
                      ? "Trebamo smjestaj"
                      : "Trebam smjestaj"}
                  </label>
                </div>

                {formData.additionalGuests.map((guestName, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <input
                      type="text"
                      placeholder="Ime i prezime"
                      value={guestName}
                      onChange={(e) =>
                        handleAdditionalNameChange(index, e.target.value)
                      }
                      required
                      className={`w-full p-3 border rounded-md flex-1 text-gray-800`}
                      style={{ borderColor: rsvp.formAddGuestColor }}
                      disabled={isEditable}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveName(index)}
                      className="text-red-500 hover:text-red-700 text-3xl"
                    >
                      &times;
                    </button>
                  </div>
                ))}
                <div className="text-center">
                  <button
                    type="button"
                    onClick={addAdditionalName}
                    className=""
                    // disabled={isEditable}
                  >
                    <EditableText
                      text={rsvp.formAddGuestText}
                      onTextChange={(text) =>
                        onUpdate({ formAddGuestText: text })
                      }
                      className={`underline cursor-pointer font-${rsvp.formAddGuestFont}`}
                      style={{
                        color: rsvp.formAddGuestColor,
                        fontSize: `${rsvp.formButtonFontSize}px`,
                      }}
                      font={rsvp.formAddGuestFont}
                      color={rsvp.formAddGuestColor}
                      fontSize={rsvp.formButtonFontSize}
                      isBold={rsvp.formAddGuestIsBold}
                      isItalic={rsvp.formAddGuestIsItalic}
                      onStyleChange={(style) => {
                        if (style.font)
                          onUpdate({ formAddGuestFont: style.font });
                        if (style.color)
                          onUpdate({ formAddGuestColor: style.color });
                        if (style.fontSize)
                          onUpdate({ formButtonFontSize: style.fontSize });
                        if (style.isBold !== undefined)
                          onUpdate({ formAddGuestIsBold: style.isBold });
                        if (style.isItalic !== undefined)
                          onUpdate({ formAddGuestIsItalic: style.isItalic });
                      }}
                      isEditable={isEditable}
                    />
                  </button>
                </div>
                <div>
                  <textarea
                    type="text"
                    id="personalMessage"
                    name="personalMessage"
                    placeholder="Poruka za mladence"
                    value={formData.personalMessage}
                    onChange={handleChange}
                    className="w-full p-3 border border-yellow-500 rounded-md text-gray-800"
                    style={{ borderColor: rsvp.formAddGuestColor }}
                    disabled={isEditable}
                  />
                </div>

                <div className="text-center mt-8">
                  <button
                    disabled={submitting}
                    type="submit"
                    className={`px-6 py-2 bg-white text-2xl rounded-md shadow ${
                      rsvp.formAddGuestIsBold ? "font-bold" : ""
                    } ${rsvp.formAddGuestIsItalic ? "italic" : ""} font-${
                      rsvp.formAddGuestFont
                    }`}
                    style={{
                      color: rsvp.formAddGuestColor,
                      fontSize: `${rsvp.formButtonFontSize + 6}px`,
                    }}
                  >
                    Pošalji
                  </button>
                </div>
              </form>
            </>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvitationForm;
